import * as yup from 'yup';

const heritierValidationSchema = yup.object().shape({
    civility: yup.string().required('La civilité est requise'),
    firstName: yup
        .string()
        .required('Le prénom est requis'),
    lastName: yup
        .string()
        .required('Le nom est requis'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
    address: yup.string().required('L\'adresse est requise'),
    profession: yup
        .string()
        .required('Le profession est requis')
});

export default heritierValidationSchema